import React from 'react';
import PropTypes from 'prop-types';

import {
  getPromotionMessage,
  getTodayPromotions,
  showPromotionsBox,
  showTodayPromotions
} from '../../helpers/promotions.helper';
import {Promotion, PromotionContent} from './Promotions.style';

const Promotions = ({promotions, page, textOnly}) => {
  const todayPromotions = getTodayPromotions(promotions.messages);
  const promotionMessage = getPromotionMessage(promotions, page);
  const showPromotionContent = showPromotionsBox(promotions, page);

  const renderPromotionMessage = promotionMessage &&
    <Promotion dangerouslySetInnerHTML={{__html: promotions[promotionMessage]}} />;

  const renderTodayPromotions = showTodayPromotions(promotions, page) &&
    todayPromotions.map(promotion =>
      promotion &&
      <Promotion key={`${promotion}${page}`}>
        {promotion}
      </Promotion>
    );

  return (
    <PromotionContent
      textOnly={textOnly}
      page={page}
      showPromotionContent={showPromotionContent}
    >
      {renderPromotionMessage}
      {renderTodayPromotions}
    </PromotionContent>
  );
};

Promotions.propTypes = {
  promotions: PropTypes.object.isRequired,
  textOnly: PropTypes.bool,
  page: PropTypes.string
};

export default Promotions;



// WEBPACK FOOTER //
// ./components/Promotions/Promotions.js